import { useEffect, useRef } from 'react'

import { usePageInfo } from '@lib/hooks/use-page-info'
import { gnarSpec } from '@lib/tracking/gnar'

import { Step } from '../utils/steps'

import { useStep } from './use-step'

type TrackingStep =
  | 'welcome'
  | 'go-agent-explainer'
  | 'proofreader-agent-explainer'
  | 'add-agents-explainer'
  | 'go-tab-explainer'
  | 'go-time'

const getTrackingStep = (step: Step): TrackingStep => {
  switch (step) {
    case Step.GrammarlyOnly:
    case Step.FullBench: {
      return 'welcome'
    }
    case Step.AgentsGo: {
      return 'go-agent-explainer'
    }
    case Step.Proofreader: {
      return 'proofreader-agent-explainer'
    }
    case Step.Plus: {
      return 'add-agents-explainer'
    }
    case Step.UseAgentSkillAnyWhere: {
      return 'go-tab-explainer'
    }
    case Step.GoTime: {
      return 'go-time'
    }
    default: {
      return 'welcome'
    }
  }
}

/**
 * Hook to track Superhuman Go Intro step impressions.
 * Tracks every step change, but only if it's different from the previous step.
 */
export const useStepImpressionTracking = () => {
  const { pageId, slug } = usePageInfo()
  const { step } = useStep()
  const previousStep = useRef<TrackingStep | null>(null)

  useEffect(() => {
    const trackingStep = getTrackingStep(step)

    // Only track if the step is different from the previous step
    if (previousStep.current === trackingStep) {
      return
    }

    previousStep.current = trackingStep

    void gnarSpec.componentShow({
      componentId: trackingStep,
      componentType: 'Section',
      pageId,
      pageSlug: slug,
    })
  }, [pageId, slug, step])
}
